import Vue from 'vue'


export default {
  namespaced: true,
  state: {},
  actions: {
    setMapState({commit}, [mapState, path]) {
      commit('SET_MAP_STATE', [mapState, path])
    }
  },
  mutations: {
    SET_MAP_STATE (state, [mapState, path]) {
      Vue.set(state, path, mapState)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/mapStates.js